import axios from '../../commons/gdprcontrol-axios'
import router from '../../commons/router.js'

const state = {
  token: null
}

const getters = {
  getToken: state => state.token,
  hasToken: state => state.token !== null
}

const actions = {
  doRegistration: async ({commit, dispatch}, registrationData) => {
    return axios.post('/api/rest-auth/registration/', registrationData)
      .then(response => {
        commit('storeToken', response.data.token)
        commit('userDetails/storeUserProfile', response.data.user, {root: true})

        router.push({name: 'landing'})
      })
  },

  login: async ({commit, dispatch}, {email, password}) => {
    return axios.post('/api/rest-auth/login/', {email, password})
      .then(response => {
        commit('storeToken', response.data.token)
        commit('userDetails/storeUserProfile', response.data.user, {root: true})

        router.push({name: 'landing'})
      })
  },

  logout: async ({commit, dispatch}) => {
    return axios.post('/api/rest-auth/logout/')
      .then(response => {
        axios.defaults.headers.common['Authorization'] = ''
        commit('storeToken', null)
        commit('userDetails/storeUserProfile', null, {root: true})

        router.push({name: 'login'})
      })
  },

  changePassword: async ({ commit }, passwordData) => {
    return axios.post('/api/rest-auth/password/change/', passwordData)
  }
}

const mutations = {
  storeToken: (state, token) => {
    state.token = token
  }
}

export default { state, getters, actions, mutations, namespaced: true }



// WEBPACK FOOTER //
// ./src/store/modules/auth.js